import { useEffect, useRef } from "react";

const useExists = () => {

  const mounted = useRef<boolean>(true);

  useEffect(() => {
    return () => {
      mounted.current = false;
    }
  }, []);

  return mounted;

}

export default useExists;